module.exports = __webpack_public_path__ + "static/media/NewsEndCountdown.dc1e5fae.wav";